module.exports = __webpack_public_path__ + "static/media/sound.77a87460.svg";